import "./i18n";
import * as React from "react";
import { createRoot } from "react-dom/client";

import { onConfigLoaded } from "./config";
import App from "./containers/App";
import { activateGTag } from "./utils/gtag";
import { migrateAuthStorage } from "./utils/migrateAuthStorage";

onConfigLoaded(() => {
  // Migrate auth storage from localStorage to cookies (backward compatibility)
  migrateAuthStorage();

  activateGTag();
  const container = document.querySelector("#root");
  const root = createRoot(container!);
  root.render(<App />);
});
